import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { Heading } from 'tradera/apps/registration/components/common/form/form-parts';
import CheckBadgeIcon from '@tradera/blueprint/theme/icons2/check-badge.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

export const FormCompleted = ({
    emailAddress,
    redirectLink,
    accountCreatedInfoText,
    sendPasswordText,
    registrationProblemsText
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <div className={'mt-7'}>
            <div className={'text-center'}>
                <CheckBadgeIcon className="icon icon-xxl" />
            </div>
            <Heading>{t('registration_account_created_heading')}</Heading>
            <div className={'mb-3'}>
                {sendPasswordText} <strong>{emailAddress}</strong>
            </div>
            <div className={'mb-3'}>{accountCreatedInfoText}</div>
            <Button
                noTransform
                theme="primary"
                fluid
                className="mb-3"
                href={toLocalizedUrl(redirectLink)}>
                {t('registration_account_created_to_tradera')}
            </Button>
            <div className={'text-center mb-3'}>{registrationProblemsText}</div>
        </div>
    );
};
